var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('img',{attrs:{"src":require("../../assets/logo.png")}}),_vm._v(" "),_c('p',[_vm._v("U bent nu uitgelogd, u wordt doorverwezen...")]),_vm._v(" "),_c('talking-bird',{attrs:{"text":"Tot snel!"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d31088a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/authentication/Logout.vue
// module id = null
// module chunks = 